import Agilecustome from '@/components/home-page-three/agile-custome';
import HomeHero from '@/components/home-page-three/home-hero';
import MetaTags from '@/components/meta-tag/meta-tag';
import Navigatedigital from '@/components/home-page-three/navigate-digital';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import Blog from '@/components/home/blog';
import Page from '../contact-us/page';
import ClientCarousel from '@/components/home/client-carousel';
import ServingMultipleIndustries from '@/components/home/serving-to-multiple-industries';
import '../styles/pagethree.css';

function Home() {
    return (
        <>
            <MetaTags />
            <meta name="robots" content="noindex, nofollow" />
            <main>
                <section className="hero bg-white home-hero">
                    <HomeHero />
                    <ClientCarousel />
                </section>
                <Agilecustome />
                {/* <Solutiontransform /> */}

                <Navigatedigital />
                <ServingMultipleIndustries />
                <CaseStudies />
                <ClientTestimonials />
                <Blog />
                <Page />
            </main>
        </>
    );
}
export default Home;
